/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { Modal } from "antd";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
import { dynamicExternalFunction } from "../../../../pages/uih/wf_controllers/BtnController/dynamicAction";
import { StatusInfo } from "../../../utility/status_info_modal";
export default function AckjobConfirmModal({
  CompanyId,
  OperatorId,
  ProjectId,
  ModalShow,
  setModalShow,
  workflowJob,
  jobDetail,
  currentPage,
  so_id,
}) {
  const [statusSubmit, setstatusSubmit] = useState(false);
  const [Spin, setSpin] = useState(true);
  const [showText, setshowText] = useState("Loading..");
  const [statusInfoMode, setstatusInfoMode] = useState("success");
  async function SendDataAckjob() {
    setshowText("Checking Your Permission");
    setstatusSubmit(true);
    workflowJob.map((data, index) => {
      if (data.from_main_process_id === 34 && data.next_main_action_id === 24) {
        Api.post("job_detail/search_employee_for_assign", {
          team_group_duty_code: "C",
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_id: jobDetail.job_id,
          employee_skill: null,
          employee_name: Cookies.get("fullName") || null,
          team_group: null,
          team_sub: null,
          is_active: 1,
        }).then((res) => {
          if (res.data.result.code === "P") {
            setshowText("Check Permission Success");
            const myData = res.data?.data.filter(
              (data) => data.emp_id === Number(Cookies.get("userId"))
            );
            if (myData.length > 0) {
              const sendAssign = [
                {
                  wf_id: 58,
                  company_id: CompanyId,
                  operator_id: OperatorId,
                  project_id: ProjectId,
                  next_flow: "M",
                  from_main_process_id: 33,
                  from_main_process_name: "Wait for assign to M&M",
                  next_main_process_id: 34,
                  next_main_process_name: "Wait for M&M ack",
                  next_main_action_id: 23,
                  next_main_action_name: "Assign (M&M)",
                  from_sub_process_id: null,
                  from_sub_process_name: "",
                  next_sub_process_id: null,
                  next_sub_process_name: "",
                  next_sub_action_id: null,
                  next_sub_action_name: "",
                  style_sheet_format:
                    "'backgroup_color:#000F9F;color:#FFFFFF;style:flat;'",
                  to_usergroup_id: Cookies.get("usergroup_id"),
                  to_usergroup_name: Cookies.get("usergroupname"),
                  to_user_id: Cookies.get("userId"),
                  to_username: Cookies.get("username"),
                  next_sub_dest_page_id: null,
                  next_sub_dest_page_name: "",
                  current_flow: "M",
                  show_dest_page: null,
                  job_no: jobDetail.job_no,
                  emp_code: Cookies.get("userId"),
                  create_by: Cookies.get("username"),
                  job_progress_id: jobDetail.job_progress_id,
                  flag_reassign: "assign",
                  emp_or_team: "E",
                  job_id: jobDetail.job_id,
                  team_id: myData[0].team_id,
                  team_group_id: myData[0].team_group_id,
                },
              ];
              Api.post("update_job_ma_to_employee_Trs", {
                employees: sendAssign,
              })
                .then((res) => {
                  setshowText("Auto Assign Job");
                  if (res.data.result.value === "P") {
                    const sendDataSent = {
                      ...workflowJob[index],
                      company_id: CompanyId,
                      operator_id: OperatorId,
                      project_id: ProjectId,
                      job_id: jobDetail.job_id,
                      job_progress_id: jobDetail.job_progress_id,
                      location_lat: "",
                      location_long: "",
                      create_by: Cookies.get("username"),
                      acknowledge_status: "Y",
                      progress_Status_flag: "",
                      jobtypeid: jobDetail.job_type_id,
                    };
                    Api.post("tabUpdateAckJobBold", sendDataSent)
                      .then((res) => {
                        if (res.data.result.code === "P") {
                          setshowText("Check External URL");
                          if (
                            workflowJob[index].external_url_type &&
                            workflowJob[index].external_url_type === "json"
                          ) {
                            const rawUrl = JSON.parse(
                              workflowJob[index].external_url
                            );
                            if (rawUrl && rawUrl.length > 0) {
                              rawUrl
                                .filter(
                                  (s) =>
                                    s.external_config.company_id == CompanyId &&
                                    s.external_config.operator_id ==
                                      OperatorId &&
                                    s.external_config.project_id == ProjectId
                                )
                                .map((datas) => {
                                  const data = datas.external_config;
                                  if (
                                    data.external_name &&
                                    data.external_name !== "" &&
                                    data.api_url &&
                                    data.api_url !== ""
                                  ) {
                                    dynamicExternalFunction[data.external_name](
                                      data.api_url,
                                      jobDetail.job_id
                                    )
                                      .then((res) => {
                                        if (res.data.Result?.Code === "P") {
                                          setshowText(
                                            "Ack Job and Call External URL Success"
                                          );
                                          setSpin(false);
                                          // window.location.reload(false);
                                        } else if (
                                          res.data.Result?.Code === "F"
                                        ) {
                                          setshowText(
                                            "Ack Job Success || Error Call External URL : " +
                                              res.data.Result.Description
                                          );
                                          setSpin(false);
                                          setstatusInfoMode("error");
                                        }
                                      })
                                      .catch((err) => {
                                        setshowText(
                                          "Ack Job Success || Error Call External URL : " +
                                            err
                                        );
                                        setSpin(false);
                                        setstatusInfoMode("error");
                                      });
                                  }
                                });
                            }
                          } else {
                            setshowText("Ack Job Success");
                            setSpin(false);
                          }
                        } else if (res.data.result.code === "F") {
                          setshowText("Error  : " + res.data.result?.showText);
                          setSpin(false);
                          setstatusInfoMode("error");
                        }
                      })
                      .catch((e) => {
                        console.log(e);
                        setshowText("Error  : " + e);
                        setSpin(false);
                        setstatusInfoMode("error");
                      });
                  } else if (res.data.result.code === "F") {
                    setshowText("Error  : " + res.data.result?.showText);
                    setSpin(false);
                    setstatusInfoMode("error");
                  }
                })
                .catch((e) => {
                  setshowText("Error  : " + e);
                  setSpin(false);
                  setstatusInfoMode("error");
                  console.log(e);
                });
            } else {
              setshowText("Error  :  You can't access this function");
              setSpin(false);
              setstatusInfoMode("error");
            }
          } else if (res.data.result?.code === "F") {
            setshowText("Error  : " + res.data.result?.showText);
            setSpin(false);
            setstatusInfoMode("error");
          }
        });
      }
    });
    if (workflowJob?.length === 0) {
      setshowText("Error  :  You can't access this function");
      setSpin(false);
      setstatusInfoMode("error");
    }
  }
  const setCloseModal = () => {
    setModalShow(false);
    setstatusSubmit(false);
  };
  const statusInfoCallBack = () => {
    setCloseModal();
    if (statusInfoMode !== "error") {
      window.location.reload();
    }
  };
  return (
    <Modal
      title={null}
      centered
      visible={ModalShow}
      footer={null}
      closable={false}
    >
      {statusSubmit ? (
        <StatusInfo
          callbackFunction={statusInfoCallBack}
          showSpinIcon={Spin}
          statusText={showText}
          mode={statusInfoMode}
        ></StatusInfo>
      ) : (
        <div className="text-center">
          <div className="row d-flex justify-content-center">
            <img
              src={Api.absoluteUrl("/img/Checking_boxes_rafiki.svg")}
              className="img-fluid"
            />
          </div>
          <div className="row d-flex justify-content-center">
            <span className="font-thai-b fs-22 c-blue">
              {`ยืนยันการรับงาน : ${jobDetail.job_no} / ${
                jobDetail.so_id ? jobDetail.so_id : so_id ? so_id : ``
              }`}
            </span>
          </div>
          <div className="row d-flex justify-content-center mt-2">
            <button
              className="btn btn-secondary"
              onClick={() => setModalShow(false)}
            >
              Close
            </button>
            {statusSubmit ? (
              <button className="btn btn-success" disabled>
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </button>
            ) : (
              <button
                className="btn btn-success"
                onClick={() => SendDataAckjob()}
              >
                Confirm
              </button>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
